import { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import { useAppStore } from "./store/useAppStore";
import Notifications from "./components/shared/Notifications";

function App() {
  const theme = useAppStore((state) => state.theme);
  const setTheme = useAppStore((state) => state.setTheme);

  useEffect(() => {
    // Aplicar tema inicial al montar el componente
    setTheme(theme);
  }, [theme, setTheme]);

  return (
    <>
      <AppRoutes />
      <Notifications />
    </>
  );
}

export default App;
